import * as moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { NumericFormat } from "react-number-format";
import ReactToPrint from 'react-to-print';
import { Button } from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Col,
  Icon,
  Row
} from "../../components/Component";
import DatePicker from "../../components/range-date-picker/RangeDatePicker";
import { GET } from "../../helper/api";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { INGREDIENT_GROUP, renderPageStyle } from "../../utils/Utils";

import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useRecoilState, } from 'recoil';
import Table from "../../components/react-table/Table";
import { getToken } from "../../helper/auth";
import { popupPNCustomerFlowAtom } from '../../state';
import SignPrintComponent from "./Components/SignPrintComponent";


const PNReportByCustomer = () => {
  const printRef = useRef();
  const {
    customerId
  } = useParams();
  const location = useLocation();
  const history = useHistory();
  const searchParams = new URLSearchParams(location.search);
  const [popupPNCustomerFlow, setPopupPNCustomerFlow] = useRecoilState(popupPNCustomerFlowAtom);


  const [data, setData] = useState([]);
  const [summary, setSummary] = useState({});
  const [updatedAt, setUpdatedAt] = useState();
  const [customer, setCustomer] = useState();
  const [smOption, setSmOption] = useState(false);

  const [rangeDate, setRangeDate] = useState({
    start: searchParams.get('start') ? moment(searchParams.get('start')).startOf('days').toDate() : moment().startOf('months').toDate(),
    end: searchParams.get('end') ? moment(searchParams.get('end')).endOf('days').toDate() : moment().endOf('days').toDate(),
  });

  const onRangeChange = (dates) => {
    const [start, end] = dates;
    setRangeDate({ start: start ? moment(start)?.startOf('days').toDate() : start, end: end ? moment(end)?.endOf('days').toDate() : end });
    if (start && end) {
      setUpdatedAt(moment().valueOf());
    }
  };



  useEffect(() => {
    const newParams = new URLSearchParams({
      start: moment(rangeDate.start).format("YYYY-MM-DD"),
      end: moment(rangeDate.end).format("YYYY-MM-DD"),
    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    })

    GET(
      `/pn-new-customer-money-flow/report-by-customer`,
      {
        fromDate: moment(rangeDate.start).format('YYYY-MM-DD'),
        toDate: moment(rangeDate.end).format('YYYY-MM-DD'),
        customerId,
      },
      true
    ).then((resp) => {
      const { data } = resp;
      setData(data.rows);
      setSummary(data.summary);
    });
  }, [updatedAt, popupPNCustomerFlow.updatedAt]);

  useEffect(() => {
    GET(`/pn-customer/${customerId}`, {}, true)
      .then(({ data }) => {
        setCustomer(data);
      })

  }, [])

  const colTable = [
    {
      Header: "Mã",
      accessor: (item) => item.id,
    },
    {
      Header: "Ngày",
      accessor: (item) => item.date,
    },
    {
      Header: "Nguyên liệu",
      accessor: (item) => item.bill?.ingredient?.name,
    },
    {
      Header: "Tài khoản",
      accessor: (item) => item.bankAccount?.name,
    },
    {
      Header: "Nhân viên",
      accessor: (item) => item.debtUser?.name,
    },
    {
      Header: "Xe",
      accessor: (item) => item?.truckId,
    },
    {
      Header: "Nội dung",
      accessor: "content",
    },
    {
      Header: "Tăng(đ)",
      className: 'text-right',
      accessor: (item) => item.calculatedAmount > 0 ? <NumericFormat
        displayType={"text"}
        value={item.calculatedAmount || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      /> : ''
    },
    {
      Header: "Giảm(đ)",
      className: 'text-right',
      accessor: (item) => item.calculatedAmount < 0 ? <NumericFormat
        displayType={"text"}
        value={Math.abs(item.calculatedAmount || 0)}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      /> : ''
    },
    {
      Header: "Số dư(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.lessDebt || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />
    },
    {
      Header: "Ghi chú",
      accessor: (item) => item.note
    },

  ];

  const exportExcel = () => {
    const params = new URLSearchParams({
      fromDate: moment(rangeDate.start).format("YYYY-MM-DD"),
      toDate: moment(rangeDate.end).format("YYYY-MM-DD"),
      customerId,
      token: getToken(),
    })
    const url = `${process.env.REACT_APP_API_URL}/api/v1/pn-new-customer-money-flow/report-by-customer-excel?${params.toString()}`;
    window.open(url, '_blank')
  };

  return (
    <React.Fragment>
      <Head title="Báo cáo"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Báo cáo</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">

                    <li>
                      <div className="form-group">
                        <div
                          className="form-control-wrap"
                          style={{ width: "200px" }}
                        >
                          <DatePicker
                            selected={rangeDate.start}
                            startDate={rangeDate.start}
                            onChange={onRangeChange}
                            endDate={rangeDate.end}
                            maxDate={new Date()}
                            selectsRange
                            className="form-control date-picker"
                          />
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="form-control-wrap">
                        <ReactToPrint
                          trigger={() => <Button>In</Button>}
                          content={() => printRef.current}
                          pageStyle={``}
                        />
                        <Button onClick={exportExcel} className="ml-3">
                          Xuất excel
                        </Button>
                        <Button
                          className="ml-3"
                          onClick={() => {
                            history.goBack();
                          }}
                        >
                          <span>Trở về</span>
                        </Button>
                      </div>
                    </li>
                  </ul>

                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div
            id="DataTables_Table_1_wrapper"
            className="dataTables_wrapper dt-bootstrap4 no-footer bg-white"
          >
            <div className="my-3">
              <Row>
                <Col md={12} >
                  <div ref={printRef}>
                    <h5 className="text-center mt-2 mb-2">Báo cáo công nợ chi tiết {customer?.name}</h5>
                    <h6 className="text-center mt-2 mb-2">Từ {moment(rangeDate.start).format('DD-MM-YYYY')} đến {moment(rangeDate.end).format('DD-MM-YYYY')} </h6>
                    <style>{renderPageStyle()}</style>
                    <Table
                      columns={colTable}
                      data={data}
                      notShowPagi={true}
                      onRowDoubleClick={(item) => {
                        if (item.billId) {
                          const group = item?.bill?.ingredient?.group;
                          if (group === INGREDIENT_GROUP.EXTERNAL_PORT_FEE) {
                            history.push(`/pn/bill-external-port-fee/${item.billId}`)
                          } else if (group === INGREDIENT_GROUP.INGREDIENT) {
                            history.push(`/pn/bill/${item.billId}`)
                          } else {
                            history.push(`/pn/bill-other/${item.billId}`)
                          }
                        } else {
                          setPopupPNCustomerFlow({
                            show: true,
                            data: {
                              id: item.id,
                              type: item.type,

                            },
                          });
                        }
                      }}

                      headerRow={<><tr className="font-weight-bold">
                        <td colSpan={6}></td>
                        <td>Tồn đầu kì(đ)</td>

                        <td></td>
                        <td></td>
                        <td className=" text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={summary.firstDebt || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={2}
                          />
                        </td>
                        <td></td>

                      </tr>
                        <tr className="font-weight-bold">
                          <td colSpan={6}></td>
                          <td>Số phát sinh</td>
                          <td className=" text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={summary.increaseAmount || 0}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={2}
                            />
                          </td>
                          <td className=" text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={Math.abs(summary.decreaseAmount || 0)}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={2}
                            />
                          </td>
                          <td className=" text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={(summary.totalDebt) || 0}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={2}
                            />
                          </td>
                          <td></td>

                        </tr>
                        <tr className="font-weight-bold">
                          <td colSpan={6}></td>
                          <td>Tồn cuối kì(đ)</td>
                          <td></td>
                          <td></td>
                          <td className=" text-right">
                            <NumericFormat
                              displayType={"text"}
                              value={summary.lastDebt || 0}
                              thousandsGroupStyle="thousand"
                              thousandSeparator=","
                              decimalScale={2}
                            />
                          </td>
                          <td></td>
                        </tr>
                      </>}
                    ></Table>
                    <SignPrintComponent />
                  </div>

                </Col>

              </Row>
            </div>
          </div>
        </Block>



      </Content>
    </React.Fragment>
  );
};

export default PNReportByCustomer;
